import PendoIcon from '../icon/pendo-icon.vue.js';
import { isValidHex, getColor, getContrastingColor } from '../../utils/color.js';

var script = {
  name: 'PendoTag',
  components: {
    PendoIcon
  },
  props: {
    type: {
      type: String,
      default: null,
      validator: type => ['success', 'info', 'error', 'warning', 'filter', 'beta', 'sdk'].includes(type)
    },
    color: {
      type: String,
      default: '#BABCC5',
      validator: color => isValidHex(color)
    },
    label: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'medium',
      validator: size => ['mini', 'small', 'medium'].includes(size)
    },
    closable: {
      type: Boolean,
      default: false
    },
    prefixIcon: {
      type: [String, Object],
      default: null
    },
    suffixIcon: {
      type: [String, Object],
      default: null
    },
    round: {
      type: Boolean,
      default: false
    },
    subtle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedPrefix() {
      if (typeof this.prefixIcon === 'string') {
        return {
          type: this.prefixIcon,
          size: 14
        };
      }
      return this.prefixIcon;
    },
    formattedSuffix() {
      if (typeof this.suffixIcon === 'string') {
        return {
          type: this.suffixIcon,
          size: 14
        };
      }
      return this.suffixIcon;
    },
    styleObject() {
      if (this.type) {
        return {};
      }
      if (this.subtle) {
        const {
          hex: backgroundColor
        } = getColor({
          hex: this.color,
          alpha: 0.15
        });
        const subtleTextColor = this.color === '#BABCC5' ? '#6A6C75' : this.color;
        return {
          backgroundColor,
          borderColor: 'transparent',
          color: subtleTextColor
        };
      }
      const textColor = getContrastingColor(this.color);
      return {
        backgroundColor: this.color,
        borderColor: this.color,
        color: textColor
      };
    },
    tagLabel() {
      if (this.type === 'beta') {
        return 'Beta';
      }
      return this.text || this.label;
    }
  },
  methods: {
    handleClose(event) {
      event.stopPropagation();
      this.$emit('close', event);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-tag.vue2.js.map
